import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { ReplyModal } from '../../modals/reply';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const ReplyNodeAttributes = {
    iconName: 'reply',
    label: 'Auto-reply',
    helpText: 'Send an automatic reply based on a custom template.',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: ReplyNode,
    ActionModal: ReplyModal,
};
export function ReplyNode({ node }) {
    const { payload } = node;
    const { templateName } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Template" }), _jsx(Text, { weight: "semibold", text: templateName })] })), [templateName]) }));
}
